import { useNavigate } from 'react-router';

import { signOutUser } from 'features/auth';
import { useLogoutUserMutation } from 'features/auth/services/auth.api';
import { clearSelectedProject } from 'features/projects';
import { LogOut } from 'lucide-react';
import baseApi from 'shared/api/baseApi';
import { useAppDispatch } from 'shared/hooks/redux';

import { SidebarFooter, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';

const AppSidebarFooter = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [logoutUser] = useLogoutUserMutation();

  const handleSignOut = () => {
    logoutUser()
      .unwrap()
      .catch(() => {});
    dispatch(clearSelectedProject());
    dispatch(signOutUser());
    dispatch(baseApi.util.resetApiState());
    void navigate('/login');
  };

  return (
    <SidebarFooter>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton onClick={handleSignOut} tooltip="Cerrar sesión">
            <LogOut />
            <span>Cerrar sesión</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarFooter>
  );
};

export default AppSidebarFooter;
